export default __webpack_public_path__ + "static/img/7.86e834e.png";